import React from 'react'
import { BreadcrumbType } from '@gql/graphql'
import { Breadcrumbs, WContainer, WImage } from '@components/atoms'
import styles from './ListingHead.module.sass'

interface Props {
  pagina?: {
    titolo?: string
    descrizione?: string
    mainImage?: string
    breadcrumbs?: BreadcrumbType[]
  }
  variant?: 'default' | 'volantino'
  className?: string
  nextImage?: boolean
}

const ListingHead = (props: Props) => {
  const { pagina = undefined, variant = 'default', className = '', nextImage = false } = props

  const getMain = () => (
    <div className={styles.main}>
      {pagina.breadcrumbs && (
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
      )}
      <div className={styles.content}>
        {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
        {!!pagina.descrizione && (
          <div
            dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
            className={styles.description}
          />
        )}
      </div>
    </div>
  )

  return pagina ? (
    <div
      className={`${styles.root} ${styles[`root--${variant}`]} ${
        pagina.mainImage ? styles['root--image'] : ''
      } ${className}`}
    >
      {pagina.mainImage ? (
        <>
          {getMain()}
          <div className={styles.imageBox}>
            <WImage
              src={pagina.mainImage}
              maxWidth={767}
              maxHeight={400}
              objectFit={variant == 'default' ? 'cover' : 'contain'}
              priority
              loading="eager"
              next={nextImage}
            />
          </div>
        </>
      ) : (
        <WContainer>{getMain()}</WContainer>
      )}
    </div>
  ) : (
    <></>
  )
}

export default ListingHead
